<a routerLink="/detailed">
    <div id="video-container">
        <div id="thumb-container">
            <img [src]= "video.thumbnailUrl" alt="">
            <p>{{video.views | shortNumber}}</p>
            <p>{{video.duration}}</p>
        </div>
        <div id="info-container">
            <div id="pp-container">
                <img [src]= "video.profileUrl"  alt="">
            </div>
            <div id="info-sub-container">
                <h3>{{video.title}}</h3>
                <div>
                    <p>{{video.profileName}}</p>
                    <p>{{video.date}}</p>
                </div> 
            </div>
        </div>
    </div>
</a>